// The compose page's suggest route, the server half of the dynamic
// keyboard's chip. The request and response are the keyboard package's own
// (`suggestRequestSchema`, `suggestResponseSchema`); this file adds only the
// path and the error body, which are the host's.
import * as z from "zod";

export const KEYBOARD_SUGGEST_PATH = "/api/keyboard/suggest";

export const keyboardSuggestErrorSchema = z.discriminatedUnion("error", [
  z.object({ error: z.literal("unauthenticated") }),
  z.object({ error: z.literal("invalid_request") }),
  z.object({ error: z.literal("method_not_allowed") }),
  z.object({ error: z.literal("unconfigured") }),
]);
export type KeyboardSuggestError = z.infer<typeof keyboardSuggestErrorSchema>;
